import { createFileRoute } from '@tanstack/react-router';
import { redirectToPastVideosTab } from '@/features/past-videos/redirects';

// The list of past videos lives on Artifacts (its Past videos tab, Kazzy 16 Oct 2026): this address lands there.
export const Route = createFileRoute('/_authed/past-videos/')({
  beforeLoad: redirectToPastVideosTab,
});
